<template>
  <div>
    <input type="hidden" id="image_value" value />
    <v-dialog v-model="membershipTermSettingModal" max-width="622">
      <v-card class="membership_benefit_icon_modal_width overflow-y-auto overflow-x-auto">
        <v-card-title class="coggiri-middle-subject pt-5 pl-5 pb-0">멤버십 혜택 아이콘 등록</v-card-title>

        <div class="d-inline-block ma-5 mt-3" style="width: 582px;">
          <div class="mt-0">
            <v-card outlined class="pt-0">
              <div class="d-flex">
                <v-card-text class="pa-0">
                  <div class="float-left ma-5">
                    <v-file-input
                      id="image"
                      v-model="image"
                      class="float-left"
                      hide-details
                      dense
                      placeholder="클릭 - 125px * 125px / 5M 이하 / gif, png, jpg(jpeg)"
                      accept="image/*"
                      @change="uploadImageChange()"
                      style="width:440px;"
                      ref="image"
                    ></v-file-input>
                    <v-btn
                      depressed
                      color="primary"
                      class="font-weight-black mr-0 white--text ml-3 mt-1 float-left"
                      @click="uploadImage()"
                      :disabled="uploadButtonDisable"
                      >업로드</v-btn
                    >
                  </div>
                </v-card-text>
              </div>
            </v-card>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import FileReader from "@tanker/file-reader";

export default {
  data: () => {
    return {
      M,
      membershipTermSettingModal: false,
      text: ``,
      image: null,
      uploadButtonDisable: true,
    };
  },
  methods: {
    show: function() {
      this.membershipTermSettingModal = true;
      this.image = null;
      this.uploadButtonDisable = true;
    },
    save: async function() {},
    uploadImageChange: async function() {
      let maxSize = 5 * 1024 * 1024; //5MB
      if (this.image) {
        let getImageSize = await this.getImageSize(this.image);
        if (getImageSize.width != 125 || getImageSize.height != 125) {
          this.image = [];
          this.uploadButtonDisable = true;
          alert("넓이 125px, 높이 125px으로 맞춰주세요.");
          return false;
        }
        if (this.image.size >= maxSize) {
          this.image = [];
          this.uploadButtonDisable = true;
          alert("이미지 용량을 줄여주세요.");
          return false;
        }

        this.uploadButtonDisable = false;
      } else {
        this.uploadButtonDisable = true;
      }
    },

    getImageSize: async function(image) {
      let _URL = window.URL || window.webkitURL;
      let objectUrl = _URL.createObjectURL(image);
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () =>
          resolve({
            width: img.width,
            height: img.height,
          });
        img.onerror = reject;
        img.src = objectUrl;
      });
    },
    uploadImage: async function() {
      //let image_value = document.getElementById("image_value").value;

      if (!this.image) {
        alert("이미지를 확인해주세요.");
        return false;
      }

      const reader = new FileReader(this.image);
      const dataUrl = await reader.readAsDataURL();
      this.$parent.benefits.image = dataUrl;
      this.membershipTermSettingModal = false;
    },
  },
};
</script>
